import * as THREE from 'three';

export const THICKNESS_BACKGROUNDS = {
  white: '#ffffff',
  lightGray: '#e5e7eb',
  black: '#000000',
  navy: '#16213e',
} as const;

export type ThicknessBackground = keyof typeof THICKNESS_BACKGROUNDS;

/** Diffuse shading preserves GLB vertex colors without metallic darkening. */
export function createThicknessMaterial(
  source: THREE.MeshStandardMaterial,
  wireframe: boolean,
): THREE.MeshLambertMaterial {
  return new THREE.MeshLambertMaterial({
    color: source.color,
    map: source.map,
    vertexColors: source.vertexColors,
    side: source.side,
    transparent: source.transparent,
    opacity: source.opacity,
    alphaMap: source.alphaMap,
    alphaTest: source.alphaTest,
    depthTest: source.depthTest,
    depthWrite: source.depthWrite,
    flatShading: true,
    toneMapped: false,
    wireframe,
  });
}
